/**
 * Constantes de Remote Config Flags
 * Use estas constantes em vez de strings hardcoded
 */

export const REMOTE_CONFIG_FLAGS = {
  SHOW_FLIGHT_DETAILS: 'show_flight_details',
  // Adicione novas flags aqui conforme necessário
  // THEME: 'theme',
  // MAX_ITEMS: 'max_items',
} as const;

// Type helper para garantir que as flags existem
export type RemoteConfigFlag =
  (typeof REMOTE_CONFIG_FLAGS)[keyof typeof REMOTE_CONFIG_FLAGS];
